export const locale = {
  no_entries: 'No recorded entries.',
  other: 'Other',
  edit: '{{entry}} - Edit',
  delete: '{{entry}} - Delete',
};
